import React from "react";
import TablaIdiomas from "js/components/TablaIdiomas";

export const Idiomas = props => <TablaIdiomas />;

export default Idiomas;
